import {Component, Input, OnInit} from '@angular/core';
import { CplItem } from '../model/cpl-item.model';
import { A48HelpersService } from '../services/a48-helpers/a48-helpers.service';
import { CplA48Labels } from '../model/cpl-a48-labels.model';
import { BaseUser, PortalSettings, SessionService } from '@edl-development/edl-common';
import { CplAssignment } from '../model/cpl-assignment.model';
@Component({
    templateUrl: './print-roster.component.html',
    styleUrls: ['./print.component.scss'],
})
export class PrintRosterComponent implements OnInit {
    @Input() printableRoster: { ContactUsers: Array<any>, ItemId: string, Roster: Array<any>};
    @Input() cplItem:CplItem;
    @Input() users: { FirstName: string, LastName: string }[]
    @Input() itemCycles: any;
    
    ContactUsers: Array<any>;
    Roster: string[];
    portalSettings:PortalSettings;
    A48Labels: CplA48Labels;

    constructor(
        public a48HelpersService: A48HelpersService,
        private sessionService: SessionService,
    ) {}

    ngOnInit() {
        this.portalSettings = this.sessionService.PortalSettings;       
        this.ContactUsers = this.cplItem.AssignedUsers.filter(
            user => user.Type === 1);

        // Requests use Users to store the submitted users
        // CPL uses itemCycles to get it's users
        this.Roster =
            this.users?.map(user => user.LastName + ', ' + user.FirstName)
            ?? this.itemCycles?.Results?.map(cycle => cycle.LastName + ', ' + cycle.FirstName)
            ?? [];

        if(this.isAct48Enabled()){
            this.A48Labels = this.a48HelpersService.getAct48DetailsLabels(this.cplItem.Act48Detail);
        }
    
    }

    isAct48Enabled(){
        return this.portalSettings.Act48Enabled && this.cplItem.Act48Detail != null && this.cplItem.Act48Detail.Applicable;
    }
}